
import { useQuery } from '@tanstack/react-query';
import { supabase } from "@/integrations/supabase/client";
import { SavedState } from '@/components/team-details/types/selector-types';

export const useTeamMatches = (
  teamName: string | undefined,
  selectedSeasons: string[],
  savedStates: SavedState[] | null
) => {
  return useQuery({
    queryKey: ['team-matches', teamName, selectedSeasons],
    queryFn: async () => {
      console.log('Fetching matches for:', { teamName, selectedSeasons });
      if (!savedStates || selectedSeasons.length === 0) return [];

      // Filter states before processing to reduce iteration overhead
      const matchingStates = savedStates.filter(state => 
        selectedSeasons.includes(state.year || '')
      );

      // Pre-allocate array size when possible
      const allMatches = [];
      
      // Process each state and collect team matches
      for (const state of matchingStates) {
        if (!Array.isArray(state.data)) continue;
        
        // Use filter with direct push instead of spread to improve performance
        const teamMatches = state.data.filter(match => 
          match.HomeTeam === teamName || match.AwayTeam === teamName
        );
        
        allMatches.push(...teamMatches);
      }

      // Sort matches by date (ascending order - oldest first)
      // Use localeCompare for string comparison to improve sorting performance
      allMatches.sort((a, b) => {
        if (!a.Date || !b.Date) return 0;
        return a.Date.localeCompare(b.Date);
      });

      return allMatches;
    },
    enabled: !!savedStates && !!teamName && selectedSeasons.length > 0,
    staleTime: 10 * 60 * 1000, // Increase stale time to 10 minutes
    gcTime: 45 * 60 * 1000, // Increase garbage collection time to 45 minutes (formerly cacheTime)
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
